export function evaluateControlState(control) {
	const value = control.value ?? '';
	const defaultValue = control.getAttribute('data-true-default') ?? '';
	const hasValue = String(value).length > 0;
	const hasChanged = String(value) !== String(defaultValue);
	control.setAttribute('data-has-value', hasValue ? 'true' : 'false');
	control.setAttribute('data-changed', hasChanged ? 'true' : 'false');
}

export function initFormControls(formId) {
	const root = typeof formId === 'string' ? document.getElementById(formId) : formId;
	if (!root) return;

	// Configure jQuery Validate to not ignore hidden selects enhanced by custom-select
	if (window.jQuery) {
		const $ = window.jQuery;
		const $form = $(root);
		const validator = $form.data('validator');
		if (validator && validator.settings) {
			validator.settings.ignore = '';
		}
	}

	const controls = root.querySelectorAll('.form-control');
	controls.forEach(control => {
		if (!control.hasAttribute('data-true-default')) {
			control.setAttribute('data-true-default', '');
		}
		evaluateControlState(control);
		control.addEventListener('input', () => evaluateControlState(control));
		control.addEventListener('change', () => evaluateControlState(control));
	});

	root.addEventListener('reset', () => {
		// After native reset, recompute state and notify custom selects to sync
		setTimeout(() => {
			root.querySelectorAll('.form-control').forEach(evaluateControlState);
			root.querySelectorAll('select[data-custom-select]').forEach(sel => {
				sel.dispatchEvent(new Event('change', { bubbles: true }));
			});
			// Clear any validation text that may be left in valid placeholders
			root.querySelectorAll('.field-validation-valid').forEach(el => { el.textContent = ''; });
		}, 0);
	});
} 